import React from 'react';

import './CustomLabel.css';

export default class CustomLabel extends React.Component {
    render() {
        return <label className="custom-label">{this.props.children}</label>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-label/CustomLabel.jsx